<script>
  import { BeerText, BeerButton } from '@xhs/yam-beer'

  export default {
    name: 'ToolBar',

    components: {
      BeerText,
      BeerButton,
    },

    props: {
      title: String,
      buttons: Array,
    },
  }
</script>

<template>
  <div class="tool-bar">
    <beer-text :bs="{ mb: 0 }">{{ title }}</beer-text>

    <div class="buttons">
      <beer-button
        v-for="({ text, bs, onClick, ...other }, i) in buttons"
        v-bind="other"
        :key="i"
        :bs="i === buttons.length - 1 ? { mr: 0, ...bs } : bs"
        @click="onClick"
      >
        {{ text }}
      </beer-button>
    </div>
  </div>
</template>

<style scoped>
.tool-bar {
  margin-bottom: 15px;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.buttons {
  display: flex;
  justify-content: flex-end;
}
</style>
